var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXtz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E84FD",
    d: "M13.594 19.278c-1.062 0-1.834-.247-2.329-.75c-.48-.502-.728-1.04-.728-1.615c0-.219.051-.393.131-.539a.9.9 0 0 1 .35-.342a1.1 1.1 0 0 1 .538-.123c.211 0 .4.043.546.123a.92.92 0 0 1 .473.874c0 .262-.058.466-.182.633a.88.88 0 0 1-.444.313c.146.203.379.342.699.43c.313.086.633.13.946.13c.424.005.84-.117 1.194-.35c.364-.232.618-.581.786-1.033c.174-.458.254-.975.254-1.55c0-.633-.087-1.164-.276-1.608a2 2 0 0 0-.8-1.005a2.2 2.2 0 0 0-1.165-.32c-.262 0-.605.11-1.012.328l-.742.364v-.364l3.347-4.302h-4.466v4.47c0 .99.762 1.68 1.643 1.033c.249-.181.465-.403.64-.655a.25.25 0 0 1 .087-.102a.18.18 0 0 1 .11-.044c.065 0 .138.036.218.094a.45.45 0 0 1 .124.306q-.015.119-.044.233a2.23 2.23 0 0 1-.8.968c-.85.565-2.39.477-3.115-.247a2.17 2.17 0 0 1-.575-1.587v-4.47H6.43v-.857h2.573V5.572l-.43-.429v-.42h1.464l.678.849v2.142h5.966l.611.502l-3.763 3.697q.341-.134.707-.167c.407 0 .873.13 1.382.385c.51.248.903.597 1.18 1.034s.458.851.53 1.252c.081.35.125.71.132 1.07a4.4 4.4 0 0 1-.459 1.98a2.94 2.94 0 0 1-1.383 1.367a4.6 4.6 0 0 1-2.023.452z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtz);
export default __webpack_public_path__ + "static/media/xtz.fb250cc671d8fae13ee86345e5c1ed5e.svg";
export { ForwardRef as ReactComponent };